export const makeRequest = async (
  url: string,
  body?: Record<string, unknown>,
  method = 'POST'
): Promise<Response | undefined> => {
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-Same-Domain': '1',
      },
      method,
      ...(body ? {body: JSON.stringify(body)} : {}),
    });
    return response;
  } catch {
    return undefined;
  }
};
